/**
 * Global variables
 */


// Basic timings
timeMultiplier = 1;
animationDelayMultiplyer = 0.5;
hoverSpeed = 300 * timeMultiplier;
fadeSpeed = 500 * timeMultiplier;
fadeSlowSpeed = 1500 * timeMultiplier;
fadeSlowerSpeed = 3000 * timeMultiplier;
barSpeed = 1000 * timeMultiplier;
glowFadeSpeed = (500 + (barSpeed - 500)) * timeMultiplier; // Glow speed + delay of how long to stay on

delay1 = fadeSpeed * (timeMultiplier * animationDelayMultiplyer);


// Last link clicked notes
lastLinkNotes = null;

